/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_footer_made_with = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Made with`)
};

const es_footer_made_with = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho con`)
};

const de_footer_made_with = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt mit`)
};

const nl_footer_made_with = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemaakt met`)
};

const fr_footer_made_with = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fait avec`)
};

const it_footer_made_with = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizzato con`)
};

const pt_br2_footer_made_with = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito com`)
};

const pt_footer_made_with = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito com`)
};

const ja_footer_made_with = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成:`)
};

const zh_footer_made_with = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由此制作`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const footer_made_with = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_made_with(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("footer_made_with", locale)
	if (locale === "en") return en_footer_made_with(inputs)
	if (locale === "es") return es_footer_made_with(inputs)
	if (locale === "de") return de_footer_made_with(inputs)
	if (locale === "nl") return nl_footer_made_with(inputs)
	if (locale === "fr") return fr_footer_made_with(inputs)
	if (locale === "it") return it_footer_made_with(inputs)
	if (locale === "pt-BR") return pt_br2_footer_made_with(inputs)
	if (locale === "pt") return pt_footer_made_with(inputs)
	if (locale === "ja") return ja_footer_made_with(inputs)
	return zh_footer_made_with(inputs)
};